var __default__ = {root:'m_f1cb205a',pinInput:'m_cb288ead'};
export default __default__;